import React, { useRef, useState } from 'react'
import {
  Grid,
  ButtonGroup as ButtonGroupComponent,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from '@material-ui/core'
import Button from '../Button'
import { MdArrowDropDown } from 'react-icons/md'
import { IButtonGroupProps } from './ButtonGroupComponent.types'

const ButtonGroup: React.FC<IButtonGroupProps> = ({
  color,
  size,
  options,
  name,
  onClick,
  disabled,
}: IButtonGroupProps) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)
  const [selectedIndex, setSelectedIndex] = useState(1)

  const handleMenuItemClick = (option, index) => {
    setSelectedIndex(index)
    setOpen(false)
    onClick(option)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  return (
    <Grid>
      <ButtonGroupComponent
        variant="contained"
        color="primary"
        ref={anchorRef}
        style={{ width: '159px' }}
        disabled={disabled}
      >
        <Button
          color={color}
          size={size}
          onClick={handleToggle}
          style={{ width: '100%' }}
        >
          {name}
          <MdArrowDropDown />
        </Button>
      </ButtonGroupComponent>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id={name}>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      value={option}
                      onClick={() => handleMenuItemClick(option, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Grid>
  )
}
export default ButtonGroup
